import React from "react";
import ReactDOM from "react-dom";
import EmbedGridDetailBase from "./EmbedGridDetailBase";
import "./EmbedGigGridDetails.css";
import { applyOztixUtm } from "../../../helper/oztixHelper";

const BASE_URL = process.env.REACT_APP_BASE_URL;

class EmbedGigGridOrganisationDetails extends EmbedGridDetailBase {
    state = {
        imgBroken:      false,
        bioExpanded:    false,
        region: null,
    };

    handleImgError = () => this.setState({ imgBroken: true });

    render() {
        const { data, open, tableFtColor, tableWidgetBgColor, tableBgColor } = this.props;
        const { imgBroken, bioExpanded } = this.state;

        if (!open || !data) return null;

        const toAbsolute = url => !url ? "" : /^https?:\/\//i.test(url) ? url : "https://" + url;
        const toAbsImg   = url => !url ? null : /^https?:\/\//i.test(url) ? url : BASE_URL + url;

        const rawBookingUrl  = data.bookTableUrl || (data.venue && data.venue.bookTableUrl) || "";
        const rawTicketUrl   = data.ticketUrl || "";
        const bookingUrl     = toAbsolute(rawBookingUrl);
        const ticketUrl      = applyOztixUtm(toAbsolute(rawTicketUrl));

        const actGenres = (data.act && data.act.actGenres) || [];
        const actName   = data.actName || (data.act && (data.act.actName || data.act.profileName)) || "";
        const venueName = data.venueName || (data.venue && (data.venue.name || data.venue.profileName)) || "";
        const bio       = (data.act && data.act.actDescription) || data.actDescription || "";
        const actId     = (data.act && data.act.id) || data.actId || null;

        const accentColor   = tableWidgetBgColor && tableWidgetBgColor !== "transparent"
            ? tableWidgetBgColor
            : (tableBgColor || "#ff0c9c");
        const accentFtColor = tableFtColor || "#fff";

        const imageUrl = data.resolvedImageUrl
            || (data.act && data.act.resolvedProfileImage)
            || toAbsImg(data.imageUrl)
            || (data.act && data.act.profileImage && toAbsImg(data.act.profileImage.url400 || data.act.profileImage.url200))
            || null;

        const overlayStyle = this.getOverlayStyle();
        const portalTarget = this.portalTarget;

        const modal = (
            <div className="embed-detail-overlay" style={overlayStyle}>
                {/* Backdrop */}
                <div
                    data-embed-backdrop
                    onClick={this.handleClose}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.55)",
                    }}
                />

                {/* Card */}
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label={actName || "Event details"}
                    className="embed-detail-card"
                    style={{
                        position: "relative",
                        background: "#fff",
                        borderRadius: 16,
                        boxShadow: "0 8px 40px rgba(0,0,0,0.28)",
                        width: "min(820px, 92vw)",
                        maxHeight: "calc(100% - 24px)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "row",
                        padding: 12,
                    }}
                >
                    <button className="embed-detail-close" onClick={this.handleClose} aria-label="Close">×</button>
                    <div className="embed-detail-scroll" ref={el => { this.scrollContent = el; }}>
                    {/* Hero image — full width */}
                        <div
                            style={{
                                position: "relative",
                                width: "48%",
                                flexShrink: 0,
                                borderRadius: 12,
                                overflow: "hidden",
                                backgroundColor: tableWidgetBgColor
                            }}
                        >
                        {!imgBroken && imageUrl && (
                            <img
                                src={imageUrl}
                                alt={actName || "Gig"}
                                onError={this.handleImgError}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "top center",
                                        display: "block",
                                        borderRadius: 12
                                    }}
                            />
                        )}
                        <div style={{ position: "absolute", bottom: 0, left: 0, width: "100%", height: "60%", background: "linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 100%)" }} />
                        <div className="topcorner" style={{ backgroundColor: tableWidgetBgColor }}>
                            <div style={{ fontSize: 19, fontFamily: "Raleway", fontWeight: "bold", color: accentFtColor }}>
                                {`${(data.day || "").toUpperCase()} ${data.date || ""}`}
                            </div>
                            <div style={{ fontSize: 15, fontFamily: "Raleway", fontWeight: "bold", color: accentFtColor }}>
                                {data.month}
                            </div>
                            <div style={{ fontSize: 11, fontFamily: "Raleway", fontWeight: "bold", color: accentFtColor }}>
                                {data.startTimeString}
                            </div>
                        </div>
                    </div>

                    {/* Info section */}
                        <div className="embed-detail-scroll" ref={el => { this.scrollContent = el; }} style={{ width: "52%", padding: "16px 24px 20px", overflowY: "auto" }}>
                            <a
                                className="clickLink"
                                onClick={() => actId && window.open(`${BASE_URL}profile/${actId}`, "_blank")}
                                    style={{
                                        fontSize: 30,
                                        fontFamily: "Raleway",
                                        fontWeight: "bold",
                                        textDecoration: profileId ? "underline" : "none",
                                        color: "black",
                                        cursor: profileId ? "pointer" : "default",
                                        display: "block",
                                        marginBottom: 4,
                                        lineHeight: 1.2,
                                    }}
                            >
                                {actName}
                            </a>

                            {venueName ? (
                                <div style={{ fontSize: 16, fontFamily: "Raleway", color: "rgba(0,0,0,0.55)", marginBottom: 10 }}>
                                    {venueName}
                                </div>
                            ) : null}

                            {actGenres.length > 0 && (
                                <div className="genreContainer" style={{ marginLeft: -5, marginBottom: 12 }}>
                                    {actGenres.map((g, i) => (
                                        <span key={i} className="genreWrapper" style={{ backgroundColor: accentColor, color: accentFtColor }}>
                                            {g.name}
                                        </span>
                                    ))}
                                </div>
                            )}

                            {bio ? (
                                <div style={{ maxWidth: 500, fontSize: 15, fontFamily: "Open Sans", color: "rgba(0,0,0,0.75)", lineHeight: 1.55 }}>
                                    <span dangerouslySetInnerHTML={{ __html: bioExpanded || bio.length <= 500 ? bio : bio.substring(0, 500) + "…" }} />
                                    {bio.length > 500 && (
                                        <span
                                            onClick={() => this.setState({ bioExpanded: !bioExpanded })}
                                            style={{ display: "inline-block", marginTop: 6, fontSize: 13, color: accentColor, cursor: "pointer", fontWeight: 600 }}
                                        >
                                            {bioExpanded ? " Show less" : " Read more"}
                                        </span>
                                    )}
                                </div>
                            ) : null}

                            <div style={{ marginTop: 28, display: "flex", flexWrap: "wrap", gap: 10 }}>
                                {bookingUrl && (
                                    <button
                                        className="buttonStyle"
                                        style={{ backgroundColor: accentColor, color: accentFtColor, border: "none", borderRadius: 6, padding: "10px 22px", fontSize: 14, fontFamily: "Raleway", cursor: "pointer" }}
                                        onClick={() => window.open(bookingUrl, "_blank")}
                                    >
                                        Book a Table
                                    </button>
                                )}
                                {ticketUrl && (
                                    <button
                                        className="buttonStyle"
                                        style={{ backgroundColor: accentColor, color: accentFtColor, border: "none", borderRadius: 6, padding: "10px 22px", fontSize: 14, fontFamily: "Raleway", cursor: "pointer" }}
                                        onClick={() => window.open(ticketUrl, "_blank")}
                                    >
                                        Buy Tickets
                                    </button>
                                )}
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
        );

        return ReactDOM.createPortal(modal, portalTarget);
    }
}

export default EmbedGigGridOrganisationDetails;
